// paragraf-karten — die Rechtsgrundlagen eines Ratgebers als Kartenraster.
//
// Sechs Karten pro Seite, je drei Felder. Als einzelne Webflow-Elemente waeren
// das 18 Textfelder, die man anklicken muss; hier ist es ein Textfeld.
//
// Die Paragrafennummer steht bewusst in einem eigenen Element und nicht im
// Fliesstext: sie ist der Anker, den Leser suchen, wenn sie etwas nachschlagen.
//
// Einstellungen am Wrapper:
//   data-titel     Ueberschrift ueber dem Raster
//   data-spalten   1–3, Standard 2
import { el, leerHinweis, lesZahl } from '@lib/bausteine/dom';
import { zerlegeZeilen } from '@lib/bausteine/zerlege';
import { zeichneAus } from '@lib/bausteine/auszeichnung';

export function paragrafKarten(wurzel: HTMLElement, quelle: string): Node {
  const karten = zerlegeZeilen(quelle);

  if (karten.length === 0) {
    return leerHinweis('Noch keine Paragrafen. Format: § 311b BGB | Kurzname | Erläuterung');
  }

  const titel = (wurzel.getAttribute('data-titel') ?? '').trim();
  const spalten = lesZahl(wurzel, 'data-spalten', 2, 1, 3);

  return el(
    'section',
    { class: 'eoe-reset eoe-paragrafen' },
    titel && el('h3', { class: 'eoe-titel' }, titel),
    el(
      'ul',
      { class: 'eoe-paragrafen__raster', style: `--eoe-spalten: ${spalten}` },
      ...karten.map((karte) => {
        const [nummer, name, text] = karte.felder;
        return el(
          'li',
          { class: 'eoe-paragrafen__karte' },
          nummer && el('p', { class: 'eoe-paragrafen__nummer' }, nummer),
          name && el('p', { class: 'eoe-paragrafen__name' }, zeichneAus(name)),
          text && el('p', { class: 'eoe-paragrafen__text' }, zeichneAus(text)),
        );
      }),
    ),
  );
}
